import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), null, {
    default: _withCtx(() => [
      (_ctx.currentDisplayCurrency)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($props.reverseTooltipPosition)
              ? _renderSlot(_ctx.$slots, "tooltip", {}, () => [
                  ($props.displayTooltip)
                    ? (_openBlock(), _createBlock(_component_tooltip, { key: 0 }, {
                        content: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "tooltip-content")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "sync",
                            class: "_tc--accent _mr-1",
                            "has-base-class": "",
                            size: "sm"
                          })
                        ]),
                        _: 3 /* FORWARDED */
                      }))
                    : _createCommentVNode("v-if", true)
                ], undefined, 0)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "content", { displayCurrency: _ctx.currentDisplayCurrency }),
            (!$props.reverseTooltipPosition)
              ? _renderSlot(_ctx.$slots, "tooltip", {}, () => [
                  ($props.displayTooltip)
                    ? (_openBlock(), _createBlock(_component_tooltip, { key: 0 }, {
                        content: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "tooltip-content")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "sync",
                            class: "_tc--accent _ml-1",
                            "has-base-class": "",
                            size: "sm"
                          })
                        ]),
                        _: 3 /* FORWARDED */
                      }))
                    : _createCommentVNode("v-if", true)
                ], undefined, 1)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "content-alt", { displayCurrency: _ctx.currentDisplayCurrency })
          ], 64 /* STABLE_FRAGMENT */))
        : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
    ]),
    _: 3 /* FORWARDED */
  }))
}